import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordTemplate } from "~/features/auth/ForgotPasswordTemplate";

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordTemplate,
});
